import { useTranslation } from '@klv/hooks/useTranslation';

import Icon from '@klv/atoms/icon';

import type { IFilterSearchInputProps } from './types';
import * as s from './styles/search-input.module.css';

const FilterSearchInput = ({
  defaultValue,
  setSearchTerm,
  placeholder,
  ...rest
}: IFilterSearchInputProps) => {
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className={s.filterSearch}>
      <Icon className={s.searchIcon} color='currentColor' iconName='Search' />
      <input 
        autoCapitalize='none'
        autoComplete='off'
        autoCorrect='off'
        value={defaultValue}
        name='query'
        placeholder={placeholder ? placeholder : t('organisms_post_filter_search')}
        spellCheck='false'
        type='text'
        onChange={handleChange}
        className={`${s.input}${rest.className ? rest.className : ''}`}
      />
      <button type="button" className={s.cancelButton} onClick={() => setSearchTerm('')}>
        <Icon className={s.cancelIcon} color='currentColor' iconName='X' />
      </button>
    </div>
  );
};

export default FilterSearchInput;
